import { initialPagination, initialState, makeListReducers } from '@/models/utils';
import { bindServices } from '@/services/api';
import CoreQueries from '@/utils/input/queries';

import { filtersConfig } from './utils';

const namespace = 'traces';
const api = bindServices(namespace);

const TraceModel = {
  namespace,
  state: {
    ...initialState,
    orderBy: 'created desc',
    filtersConfig,
    list: [],
  },
  effects: {
    *fetchData({ payload }, { call, put, select }) {
      try {
        const pagination = yield select((state) => state[namespace].pagination);
        const pageSize = yield select((state) => state.global.pageSize);
        const res = yield call(api.getAll, {
          route: payload.route ? payload.route : 'trace/paged',
          params: {
            limit: pageSize,
            ...CoreQueries.Trace.paged,
            ...pagination,
            ...payload,
          },
          readPriority: true,
        });

        yield put({
          type: 'queryData',
          payload: { ...res, limit: pageSize, page: payload.page },
        });
      } catch (e) {}
    },

    *fetchItem({ payload }, { call, put }) {
      try {
        yield put({ type: 'success', payload: false });
        const res = yield call(api.getById, {
          route: 'trace',
          id: payload.id,
          params: {
            ...(payload.detail ? CoreQueries.Trace.itemDetail : {}),
            ...(payload?.params && { ...payload.params }),
          },
        });
        yield put({ type: 'queryItem', payload: res });
      } catch (e) {}
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'queryOrderBy',
        payload,
      });
    },

    *openDrawerView({ payload }, { put }) {
      yield put({
        type: 'openDrawerViewReducer',
        payload,
      });
    },
    *closeDrawerView({ payload }, { put }) {
      yield put({
        type: 'closeDrawerViewReducer',
        payload,
      });
    },
  },
  reducers: {
    ...makeListReducers({
      initialPagination,
      initialState: {
        ...initialState,
        filtersConfig,
      },
    }),

    openDrawerViewReducer(state, { payload }) {
      return {
        ...state,
        id: payload.id,
        openView: payload.state,
        item: {},
        view: true,
      };
    },
    closeDrawerViewReducer(state, { payload }) {
      return {
        ...state,
        id: null,
        openView: payload.state,
        item: null,
        view: false,
      };
    },
  },
};

export default TraceModel;
